export interface UpdateConvertShelfTypeRequest {
  branchCode: string
  info: {
    id: number
    shelfType: string
    collectionType: string
    mark: string
    startNdc: string
    startBook: string
    startSub: string
    endNdc: string
    endBook: string
    endSub: string
    revision: number
  }[]
}

export function UpdateConvertShelfTypeRequestToJSON(
  value: UpdateConvertShelfTypeRequest
): any {
  return {
    branch_code: value.branchCode !== '' ? value.branchCode : undefined,
    info:
      value.info.length > 0
        ? value.info.map(item => {
            return {
              id: item.id !== 0 ? item.id : 0,
              shelf_type: item.shelfType !== '' ? item.shelfType : undefined,
              collection_type:
                item.collectionType !== '' ? item.collectionType : undefined,
              mark: item.mark !== '' ? item.mark : undefined,
              start_ndc: item.startNdc !== '' ? item.startNdc : undefined,
              start_book: item.startBook !== '' ? item.startBook : undefined,
              start_sub: item.startSub !== '' ? item.startSub : undefined,
              end_ndc: item.endNdc !== '' ? item.endNdc : undefined,
              end_book: item.endBook !== '' ? item.endBook : undefined,
              end_sub: item.endSub !== '' ? item.endSub : undefined,
              revision: item.revision !== 0 ? item.revision : 0
            }
          })
        : []
  }
}
